import { useShiftModalDataContext } from 'components/ShiftModal/ShiftModalProvider.data.context';
import { useSendToAgenciesFormContext } from 'components/ShiftModal/src/views/SendToAgenciesView/SendToAgencies.form.context';
import { useSSFBehaviors } from 'hooks';
import { SSFBehaviorsContextType } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import { QUERY_sendToAgenciesSummaryViewTeamMembersCount } from 'queries';
import { FC, useContext, useMemo } from 'react';
import { SendToAgenciesSummaryViewTeamMembersCountQuery } from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';

export const FetchAvailableTeamMembersCountDataContext = createGQLDataContext<
  SSFBehaviorsContextType<SendToAgenciesSummaryViewTeamMembersCountQuery>
>({} as SSFBehaviorsContextType<SendToAgenciesSummaryViewTeamMembersCountQuery>);

export const FetchAvailableTeamMembersCountDataProvider: FC = ({ children }) => {
  const { data: fetchOrderData } = useShiftModalDataContext();
  const { values: formValues } = useSendToAgenciesFormContext();

  const [values, rest] = useSSFBehaviors({
    key: 'SEND_TO_AGENCIES_SUMMARY_VIEW_FETCH_AVAILABLE_TEAM_MEMBERS_COUNT',
    query: QUERY_sendToAgenciesSummaryViewTeamMembersCount,
    payloadTransformer: (variables) => ({
      ...variables,
      filter: {
        belongingToTeam: variables.isDedicated
          ? {
              forPositions: [variables.positionId],
              inCommunities: [variables.communityId],
            }
          : undefined,
      },
    }),
    schema: {
      orderId: {
        initialValue: fetchOrderData.fetchOrder!.relayId,
      },
      isDedicated: {
        initialValue: formValues.isDedicated,
      },
      positionId: {
        initialValue: fetchOrderData.fetchOrder!.position.id,
      },
      communityId: {
        initialValue: fetchOrderData.fetchOrder!.community.id,
      },
      breakTime: {
        initialValue: fetchOrderData.fetchOrder?.orderSchedule?.breakTime,
      },
    },
  });

  const contextValue = useMemo(() => ({ values, ...rest }), [rest, values]);

  return (
    <FetchAvailableTeamMembersCountDataContext.Provider value={contextValue}>
      {children}
    </FetchAvailableTeamMembersCountDataContext.Provider>
  );
};

export const useFetchAvailableTeamMembersCountDataContext =
  (): SSFBehaviorsContextType<SendToAgenciesSummaryViewTeamMembersCountQuery> =>
    useContext(FetchAvailableTeamMembersCountDataContext);
